import './spacer.scss';

type Props = {}

const Spacer: React.FC<Props> = () => {
  return <span className='spacer'></span>
}
export default Spacer;